import gql from 'graphql-tag';

export default gql`
  mutation AddPhoneNumber($phoneNumber: String!) {
    AddPhoneNumber(countryCode: "1", phoneNumber: $phoneNumber) {
      status
      phoneNumber
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Trust/sendVerificationSmsM.js